import { Check } from 'lucide-react'

export type OnboardingProgressStep = {
  title: string
  description: string
}

export const managerOnboardingSteps: OnboardingProgressStep[] = [
  {
    title: 'Create your account',
    description: 'Create the manager account you will use to manage the Mail Percent workspace.'
  },
  {
    title: 'Organisation details',
    description: 'Confirm the manager name and the organisation this workspace belongs to.'
  },
  {
    title: 'Email workspace model',
    description: 'Choose whether customer email is handled through personal inboxes, shared inboxes, or both.'
  },
  {
    title: 'Teams & schedules',
    description: 'Add customer-email teams, planned members, working days and operating hours.'
  },
]

export const employeeOnboardingSteps: OnboardingProgressStep[] = [
  {
    title: 'Create your employee account',
    description: 'Use your own work email so Mail Percent can identify you correctly.'
  },
  {
    title: 'Open your invitation link',
    description: 'Enter your work email and join the organisation your manager invited you to.'
  },
  {
    title: 'Connect your work inbox',
    description: 'Authorise Gmail or Outlook once so Mail Percent can measure your work through the provider API.'
  },
]

type OnboardingProgressCardProps = {
  steps: OnboardingProgressStep[]
  currentStep: number
  sectionLabel: string
  heading: string
}

export function OnboardingProgressCard({ steps, currentStep, sectionLabel, heading }: OnboardingProgressCardProps) {
  return <div className={`auth-showcase-panel auth-showcase-panel-steps-only onboarding-progress-card onboarding-progress-card-${steps.length}`}>
    <span className="eyebrow">Mail Percent onboarding</span>

    <div className="auth-showcase-steps auth-showcase-steps-only">
      <div className="auth-showcase-steps-head auth-showcase-steps-head-sleek">
        <small>{sectionLabel}</small>
        <strong>{heading}</strong>
      </div>

      <div className="auth-step-list auth-step-list-sleek">
        {steps.map((step, index) => {
          const stepNumber = index + 1
          const isComplete = stepNumber < currentStep
          const isActive = stepNumber === currentStep

          return <article
            className={`auth-step-card auth-step-card-sleek ${isActive ? 'active' : ''} ${isComplete ? 'complete' : ''}`}
            key={step.title}
            aria-current={isActive ? 'step' : undefined}
          >
            <span className="auth-step-number">{isComplete ? <Check size={16}/> : stepNumber}</span>
            <div>
              <strong>{step.title}</strong>
              <small>{step.description}</small>
            </div>
            <span className="auth-step-status">{isComplete ? 'Done' : isActive ? 'Now' : 'Next'}</span>
          </article>
        })}
      </div>
    </div>
  </div>
}
